<!-- Default Navbar -->
<div class="navbar-area relative z-3">

  <div class="influx-nav">
      <div class="container xl:max-w-full 3xl:max-w-[1700px]">
          <nav class="navbar flex navbar-orange" [class.active]="classApplied">

              <!-- Logo SOLFIUM -->
              <a class="navbar-brand self-center py-3 logo-navbar" href="https://pre.solfium.com">
                  <img src="./assets/img/solfium/logo_solfium_solar_energy.webp" alt="logo">
              </a>

              <button aria-label="navbar-toggler-button" class="navbar-toggler d-lg-none" type="button" (click)="toggleClass()">
                  <span class="burger-menu">
                      <span class="top-bar"></span>
                      <span class="middle-bar"></span>
                      <span class="bottom-bar"></span>
                  </span>
              </button>

              <div class="navbar-collapse flex self-center grow basis-auto text-white content-menu-orange">
                <ul class="self-center flex-row hidden md:hidden bg-orange py-3 px-60 sm:hidden lg:flex"style="justify-content: space-evenly; align-items: center">
                      <li style="flex: 0 0 auto; margin-right: 20px;">
                        <a routerLink="./" class="block font-semibold text-16px">{{'start' | translate}}</a>
                      </li>
                      <li class="ml-12 xl:ml-15 dropdown">
                        <a class="block font-semibold text-16px">{{'us' | translate}}</a>
                        <ul class="dropdown-content">
                          <li><a routerLink="/alliances">{{'alliances_navbar' | translate}}</a></li>
                          <li><a routerLink="/culture">{{'culture_navbar' | translate}}</a></li>
                          <li><a routerLink="/success-stories">{{'history_navbar' | translate}}</a></li>
                        </ul>
                      </li>
                      <li class="ml-12 xl:ml-15">
                        <a routerLink="/quotation" class="block font-semibold text-16px">{{'quoter' | translate}}</a>
                      </li>
                      <li class="ml-12 xl:ml-15 dropdown">
                        <a class="block font-semibold text-16px">{{'solutions_navbar' | translate}}</a>
                        <ul class="dropdown-content">
                          <li><a routerLink="/residential">{{'residential' | translate}}</a></li>
                          <li><a routerLink="/commercial">{{'commercial' | translate}}</a></li>
                          <li><a routerLink="/industrial">{{'industrial' | translate}}</a></li>
                        </ul>
                      </li>
                      <li class="ml-12 xl:ml-15">
                        <a routerLink="/news" class="block font-semibold text-16px">{{'blog_navbar' | translate}}</a>
                      </li>
                      <li>
                          <button  mat-icon-button [matMenuTriggerFor]="menu"  style="margin-left: 30px"  class="dropdown-arrow">
                              <img alt="language flag" class="w-35" src="./assets/img/flags/{{flag_select | uppercase}}.png"  style="display: inline-block">
                          </button>
          
                          <mat-menu #menu="matMenu">
                              <button *ngFor="let lenguage of array_lenguage" mat-menu-item (click)="changeLanguage(lenguage)" onclick="updateIframeSolfiumNews();">
                                  <img alt="language" class="w-35" src="./assets/img/flags/{{lenguage | uppercase}}.png">
                              </button>
                          </mat-menu>
                      </li>
                  </ul>

                  <ul class="navbar-nav-for-responsive lg:hidden text-gray-logo-solfium-color">
                    <li style="flex: 0 0 auto; margin-right: 20px;">
                      <a routerLink="./" class="block font-semibold text-16px">{{'start' | translate}}</a>
                    </li>
                    <li class="ml-12 xl:ml-15">
                      <a routerLink="/about" class="block font-semibold text-16px">{{'us' | translate}}</a>
                    </li>
                    <li class="ml-12 xl:ml-15">
                      <a routerLink="/quotation" class="block font-semibold text-16px">{{'quoter' | translate}}</a>
                    </li>
                    <li class="ml-12 xl:ml-15">
                      <a routerLink="/residential" class="block font-semibold text-16px">{{'residential' | translate}}</a>
                    </li>
                    <li class="ml-12 xl:ml-15">
                      <a routerLink="/commercial" class="block font-semibold text-16px">{{'commercial' | translate}}</a>
                    </li>
                    <li class="ml-12 xl:ml-15">
                        <a routerLink="/industrial" class="block font-semibold text-16px">{{'industrial' | translate}}</a>
                    </li>
                    <li class="dropdown-arrow">
                      <button  mat-icon-button [matMenuTriggerFor]="menu" >
                          <img alt="language flag" class="w-35" src="./assets/img/flags/{{flag_select | uppercase}}.png">
                      </button>
      
                      <mat-menu #menu="matMenu">
                          <button *ngFor="let lenguage of array_lenguage" mat-menu-item (click)="changeLanguage(lenguage)" onclick="updateIframeSolfiumNews();">
                              <img alt="language" class="w-35" src="./assets/img/flags/{{lenguage | uppercase}}.png">
                          </button>
                      </mat-menu>
                  </li>
                  </ul>
              </div>

              <div class="navbar-collapse flex self-center py-3">
                <ul class="flex flex-wrap list-reset pl-0 mb-0 float-none float-md-end btn-verdes-wrap">
                  <li routerLink="/download" href="/download" style="padding-right: 3.5rem !important; padding-left: 3.5rem !important;"class=" button-verde inline-block py-2 no-underline text-white">{{'download' | translate}}</li>
                  <li routerLink="/login" href="/login" class=" button-verde inline-block py-2 no-underline text-white">Login</li>
                </ul>
              </div>
          </nav>
      </div>
  </div>
</div>

<!-- <li routerLink="/download" class=" button-verde"><a class="inline-block py-2 px-4 no-underline text-white">{{'download' | translate}}</a></li>
<li routerLink="/login" class=" button-verde"><a class="inline-block py-2 px-4 no-underline text-white">Login</a></li> -->


